
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Home from './Pages/Home';
import About from './Pages/About';
import Services from './Pages/Services';
import WellboreCleaning from './Pages/servicesDetailPages/WellboreCleaning';
import Filtration from './Pages/servicesDetailPages/Filtration';
import Fishing from './Pages/servicesDetailPages/Fishing';
import Wellhead from './Pages/servicesDetailPages/WellHead';
import Projects from './Pages/Projects';
import Contact from './Pages/Contact';
import WOW from "wowjs";
import "animate.css";
import { useEffect } from 'react';

function App() {

    useEffect(() => {
    const wow = new WOW.WOW({
      live: false, 
      mobile: true,
    });
    wow.init();
  }, []);

 

  
  return (
    <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/wellbore_cleaning_service" element={<WellboreCleaning />} />
            <Route path="/filtration" element={<Filtration />} />
            <Route path="/fishing" element={<Fishing />} />
            <Route path="/wellHead_maintenance" element={<Wellhead />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </BrowserRouter>
    </div>
  );
}

export default App;
